<template>
  <component :is="way" :vacancy-id="vacancyId" />
</template>

<script>
import basic from './default.vue';
import PROCESS_NAMES from '@/process/names';
import { mapGetters } from 'vuex';
const BcgTest = () => import(/* webpackChunkName: "bcg-test" */ '@/process/bcg-test/components/vacancy/test/index');
const schlumCareerTest = () =>
  import(/* webpackChunkName: "schlum-career-test" */ '@/process/schlumberger-career/components/vacancy/tests/index');
const SchlumCareer = () =>
  import(/* webpackChunkName: "schlum-career" */ '@/process/schlumberger-career/components/vacancy/teststoggle/index');
// const Kpmg = () => import(/* webpackChunkName: "kpmg" */ '@/process/kpmg/components/vacancy/tests/KpmgTestManagement');

export default {
  name: 'TestsIndex',

  components: {
    default: basic,
    BcgTest,
    schlumCareerTest,
    SchlumCareer
    // Kpmg
  },

  beforeRouteLeave(to, from, next) {
    let c = true;
    if (this.has_changes) {
      c = confirm(this.$tr('vacancy.confirm.leave'));
      if (!c) {
        next(false);
        return false;
      }
    }
    next();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.getters['vacancy_new/modules/allow_tests'] === false) {
        next({ name: 'vacancy_basic' })
      }
    });
  },

  props: {
    vacancyId: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    ...mapGetters('tests', ['has_changes']),

    ...mapGetters('vacancy_new', ['process']),

    way() {
      if (
        this.process === PROCESS_NAMES.BCG_TEST ||
        this.process === PROCESS_NAMES.SCHLUMBERGER_CAREER ||
        // this.process === PROCESS_NAMES.KPMG ||
        this.process === 'schlum-career-test'
      ) {
        return this.process;
      } else {
        return 'default';
      }
    }
  }
};
</script>
